<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <!--表格-->
            <div class="tbl-scroll-host">
            <el-table :data="users" v-loading="listLoading" style="width: 100%; margin-top: 20px;" height="100%"
                ref="table" class="custom-tbl" @select="dialogCheck" @row-click="selectCurrentRow">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="Name" label="姓名" min-width="">
                </el-table-column>
                <el-table-column label="关联教师" min-width="">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.TeacherId" type="primary" size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DepartmentName" label="所属部门" min-width="">
                </el-table-column>
                <el-table-column label="所属校区">
                    <template slot-scope="scope">
                        <el-tag v-if="getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
                        <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Enabled" label="状态" width="" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
                            {{ scope.row.Enabled ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="权限" min-width="140" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.CanApprove !== false" type="success" size="mini" effect="plain" style="margin-right: 4px;">审批</el-tag>
                        <el-tag v-if="scope.row.CanAgentApply !== false" type="warning" size="mini" effect="plain">代申请</el-tag>
                        <span v-if="scope.row.CanApprove === false && scope.row.CanAgentApply === false">-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" width="" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="170" align="center">
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <!--分页-->
            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <!--编辑界面-->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="40%" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                    <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%" clearable
                            @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="教师" prop="TeacherId">
                        <div class="ps-pick-summary">
                            <span v-if="editForm.TeacherId">
                                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
                            </span>
                            <span v-else class="muted-text">请选择一名教职工</span>
                            <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
                            <el-button v-if="editForm.TeacherId" type="text" size="mini" @click="clearTeacherPick">清空</el-button>
                        </div>
                        <div class="form-tip">从通讯录选择，仅绑定一人</div>
                    </el-form-item>
                    <el-form-item label="姓名" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-switch v-model="editForm.Enabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="权限" required>
                        <el-checkbox v-model="editForm.CanApprove">审批</el-checkbox>
                        <el-checkbox v-model="editForm.CanAgentApply">代申请</el-checkbox>
                        <div style="color: #909399; font-size: 12px; line-height: 1.5; margin-top: 4px;">
                            审批：可被选入调代课审批流程；代申请：可替其他老师提交调代课。<span style="color: #F56C6C;">至少勾选一项。</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="personPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="editForm.DepartmentId || DepartmentId"
                :value="editForm.TeacherId"
                :label="selectedPersonLabel"
                @confirm="onPersonPicked"
            />
        </section>
    </section>
</template>

<script>
import { getScheduleAdminListPage, addScheduleAdmin, editScheduleAdmin, removeScheduleAdmin, getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';

export default {
    components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
    data() {
        return {
            filters: {
                campusId: null
            },
            campusOptions: [],
            searchList: [
                { label: '姓名', key: 'name' },
                {
                    label: '选择校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    options: [], // 将在运行时同步
                },
            ],
            users: [],
            total: 0,
            page: 1,
            PageSize: 10,
            listLoading: false,
            buttonList: [],
            DepartmentId: 0,
            currentRow: null,

            // 编辑相关
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            personPickerVisible: false,
            selectedPersonLabel: '',
            editFormRules: {
                CampusId: [{ required: true, message: "请选择所属校区", trigger: "change" }],
                Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                TeacherId: [{ required: true, message: "请选择教师", trigger: "change" }],
            },
            editForm: {
                Id: 0,
                Name: '',
                DepartmentId: 0,
                CampusId: null,
                TeacherId: null,
                Enabled: true,
                CanApprove: true,
                CanAgentApply: true,
                Remark: '',
            }
        };
    },
    methods: {
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.filters.campusId = null;
            this.loadCampusOptions(this.DepartmentId);
            this.$nextTick(() => {
                if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                    this.$refs.toolbar.searchObj.campusId = null;
                }
                this.handleQuery();
            });
        },
        handleQuery() {
            this.page = 1;
            this.getUsers();
        },
        getUsers() {
            let para = {
                page: this.page,
                intPageSize: this.PageSize,
                departmentId: this.DepartmentId,
                ...this.filters
            };
            // 规范化校区ID，如果为null或空，则后端通常期望0或不传
            if (para.campusId === null || para.campusId === undefined) {
                para.campusId = 0;
            }
            this.listLoading = true;
            getScheduleAdminListPage(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.users = res.data.response.data;
                this.currentRow = null;
                this.listLoading = false;
            });
        },
        dialogCheck(selection, row) {
            this.currentRow = null;
            this.$refs.table.clearSelection();
            if (selection.length === 0) {
                return;
            }
            if (row) {
                this.selectCurrentRow(row);
            }
        },
        selectCurrentRow(val) {
            if (!val) {
                return;
            }
            this.currentRow = val;
            this.$refs.table.clearSelection();
            this.$nextTick(() => {
                this.$refs.table.toggleRowSelection(val, true);
            });
        },
        resolveSelectedRow(row) {
            // 行内按钮传入真实行；工具栏传入按钮配置对象，改用复选框选中行
            if (row && row.Id) {
                return row;
            }
            return this.currentRow;
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.getUsers();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = {
                    name: item.search
                };
            }
            this[item.Func].apply(this, item)
        },
        handleAdd() {
            // 限制：必须先在左侧选择具体的学校机构才能进行新增
            if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
                this.$message.warning("请先在左侧选择具体的学校机构！");
                return;
            }
            this.dialogTitle = "新增课表管理员";
            this.editFormVisible = true;
            this.selectedPersonLabel = '';
            this.loadCampusOptions(this.DepartmentId);

            // 初始化表单数据
            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: this.DepartmentId,
                CampusId: this.filters.campusId,
                TeacherId: null,
                Enabled: true,
                CanApprove: true,
                CanAgentApply: true,
                Remark: '',
            };

            // 清除之前的验证信息
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        handleEdit(row) {
            const target = this.resolveSelectedRow(row);
            if (!target) {
                this.$message.error('请选择要编辑的一行数据！');
                return;
            }
            this.dialogTitle = "编辑课表管理员";
            this.editFormVisible = true;
            this.editForm = Object.assign({}, target);
            // 优先使用当前记录绑定的所属学校 ID，若无则使用当前页面统一选中的 ID 兜底
            this.editForm.DepartmentId = target.DepartmentId || this.DepartmentId;
            this.selectedPersonLabel = target.TeacherName || target.Name || '';
            // 兼容旧数据：字段缺失时默认勾选。最后更新：2026-09-09
            if (this.editForm.CanApprove === undefined || this.editForm.CanApprove === null) {
                this.$set(this.editForm, 'CanApprove', true);
            }
            if (this.editForm.CanAgentApply === undefined || this.editForm.CanAgentApply === null) {
                this.$set(this.editForm, 'CanAgentApply', true);
            }

            // 处理校区为0的情况，避免显示0，使用 $set 确保响应式
            if (this.editForm.CampusId === 0 || this.editForm.CampusId === '0') {
                this.$set(this.editForm, 'CampusId', null);
            }

            this.loadCampusOptions(this.editForm.DepartmentId);

            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        handleDel(row) {
            const target = this.resolveSelectedRow(row);
            if (!target) {
                this.$message.error('请选择要删除的一行数据！');
                return;
            }
            const campusName = this.getCampusName(target.CampusId);
            const teacherName = target.TeacherName || target.Name || '-';
            const campusText = campusName !== '-' ? campusName : '未关联校区';
            this.$confirm(
                `确认删除校区「${campusText}」教师「${teacherName}」的课表管理员记录吗？`,
                '提示',
                { type: 'warning' }
            ).then(() => {
                this.listLoading = true;
                removeScheduleAdmin({ id: target.Id }).then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getUsers();
                    } else {
                        this.$message.error(res.data.msg || '删除失败');
                    }
                }).catch(() => { this.listLoading = false; });
            });
        },
        loadCampusOptions(deptId) {
            const schoolId = deptId || this.DepartmentId;
            if (schoolId > 0) {
                getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                    if (res.data.success) {
                        this.campusOptions = res.data.response.data || [];
                        // 同步搜索栏配置
                        const campusSearch = this.searchList.find(e => e.key === 'campusId');
                        if (campusSearch) {
                            campusSearch.options = this.campusOptions.map(e => ({
                                label: e.Name,
                                value: e.Id
                            }));
                        }
                    }
                });
            } else {
                this.campusOptions = [];
                const campusSearch = this.searchList.find(e => e.key === 'campusId');
                if (campusSearch) campusSearch.options = [];
            }
        },
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    if (!this.editForm.CanApprove && !this.editForm.CanAgentApply) {
                        this.$message.warning('请至少勾选「审批」或「代申请」一项权限');
                        return;
                    }
                    this.editLoading = true;
                    let para = Object.assign({}, this.editForm);

                    const apiCall = para.Id > 0 ? editScheduleAdmin : addScheduleAdmin;
                    apiCall(para).then((res) => {
                        if (res.data.success) {
                            this.$message({ message: '提交成功', type: 'success' });
                            this.editFormVisible = false;
                            this.getUsers();
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                        this.editLoading = false;
                    }).catch(() => {
                        this.editLoading = false;
                    });
                }
            });
        },
        /** 换校区时清空已选教师（权限范围变更）。创建于 2026-09-23 */
        handleCampusChange() {
            this.clearTeacherPick();
        },
        getCampusName(campusId) {
            if (!campusId || campusId === 0 || campusId === '0' || !this.campusOptions.length) return '-';
            const campus = this.campusOptions.find(c => c.Id === campusId);
            return campus ? campus.Name : '-';
        },
        /** 打开内部通讯录单选教职工。创建于 2026-09-23 */
        openPersonPicker() {
            const schoolId = this.editForm.DepartmentId || this.DepartmentId;
            if (!schoolId) {
                this.$message.warning('请先在左侧选择学校！');
                return;
            }
            this.personPickerVisible = true;
        },
        clearTeacherPick() {
            this.editForm.TeacherId = null;
            this.selectedPersonLabel = '';
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
            });
        },
        onPersonPicked(person) {
            if (!person) return;
            this.editForm.TeacherId = person.id;
            this.selectedPersonLabel = person.name || '';
            if (person.name) this.editForm.Name = person.name;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.validateField('TeacherId');
                    this.$refs.editForm.validateField('Name');
                }
            });
        },
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        // 手动添加一个查询按钮
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({
                name: '查询',
                Func: 'handleQuery',
                id: 999
            });
        }
    }
};
</script>

<style scoped>
.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
/* 单选模式：隐藏表头全选复选框 */
.custom-tbl >>> .el-table__header-wrapper .el-checkbox {
    display: none;
}
.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}
.muted-text {
    color: #94a3b8;
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 6px;
}
</style>
